<div class="row" *ngIf="loading">
  <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
</div>

<div *ngIf="autoSaveLoading" class="autosave-icon-fixed">
  <mat-icon class="blink">cloud_upload</mat-icon>
</div>

<div class="row" style="background-color: #F1F2F2" *ngIf="survey">
  <div class="container mt-3" style="background-color: #F1F2F2">
    <div class="alert alert-info my-3 text-center" role="alert" *ngIf="survey?.answered && !justSubmitted">
      {{ (answerStatus == 'SENT' ? "generic.questionnaire-sent" : "components.responses.info-draft-date") | translate
      }}. <br><span *ngIf="answerTimestamp">
        {{'components.responses.info-sent-date' | translate}} {{ answerTimestamp | formatdate | date:'short'}}</span>
    </div>
    <mat-stepper *ngIf="(!survey?.answered && !impersonateEmail) || justSubmitted" [linear]="true" #stepper
      style="background-color: #F1F2F2">
      <!-- Anagraphic Form Template -->
      <ng-template #anagraphicFormContent>
        <form [formGroup]="userInfoForm">
          <div class="box flex-column my-0 pb-0 pt-3 px-3 border-0">
            <mat-form-field appearance="fill">
              <mat-label>{{ "generic.name" | translate }}</mat-label>
              <input formControlName="name" [(ngModel)]="survey.user.name"
                [required]="survey.customs?.anagraphic_is_mandatory !== false" matInput>
            </mat-form-field>
          </div>
          <div class="box flex-column my-0 pb-0 pt-3 px-3 border-0">
            <mat-form-field appearance="fill">
              <mat-label>{{ "generic.email" | translate }}</mat-label>
              <input type="email" [email]="true" [(ngModel)]="survey.user.email" formControlName="email"
                [required]="survey.customs?.anagraphic_is_mandatory !== false" matInput>
            </mat-form-field>
          </div>
        </form>
      </ng-template>

      <!-- START: Anagraphic Form Step -->
      <mat-step *ngIf="shouldShowAnagraphicAt('START')" [stepControl]="userInfoForm">
        <ng-template matStepLabel>{{ "generic.generic-info" | translate }}</ng-template>
        <div class="mt-5">
          <ng-container *ngTemplateOutlet="anagraphicFormContent"></ng-container>
        </div>
        <div class="row justify-content-end mt-5 mx-1">
          <button class="btn-custom border-0 d-flex align-items-center px-5 py-2" matStepperNext>
            <mat-icon class="mr-2">play_circle_outlined</mat-icon>
            {{'generic.next' | translate}}
          </button>
        </div>
      </mat-step>

      <!-- Intro Step -->
      <mat-step>
        <div class="mt-4">
          <ng-template matStepLabel>{{ "generic.introduction" | translate }}</ng-template>
          <p class="label-box font-weight-bold">{{ "components.decision-table.new-decision-table.compile-proposal.title"
            | translate}}</p>
          <p>{{ survey?.title }}</p>
          <ng-container *ngIf="survey.description">
            <p class="label-box font-weight-bold mt-4">{{ "generic.description" | translate}}</p>
            <p class="preserve-whitespace">{{ survey?.description }}</p>
          </ng-container>
          <ng-container *ngIf="survey?.attachments?.length > 0">
            <app-attachments-list [attachments]="survey?.attachments" />
          </ng-container>
          <div class="row justify-content-end mt-3">
            <button class="btn-custom border-0 d-flex align-items-center px-5 py-2" matStepperNext>
              <mat-icon class="mr-2">play_circle_outlined</mat-icon>
              {{'generic.next' | translate}}
            </button>
          </div>
        </div>
      </mat-step>

      <!-- Questions Step -->
      <mat-step [label]="'generic.questions' | translate">
        <div>
          <div class="mt-5">
            <app-survey-details [surveyObj]="survey" [isResponse]="true" />
          </div>
          <div class="row my-5" *ngIf="loading">
            <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
          </div>
          <div class="row justify-content-between mt-3">
            <button [disabled]="loading" class="btn-custom border-0 d-flex align-items-center px-5 py-2"
              matStepperPrevious>
              {{'generic.back' | translate}}
            </button>
            <button [disabled]="loading" *ngIf="survey?.customs?.draft_answer_is_enabled"
              class="btn-custom border-0 d-flex align-items-center px-5 py-2 ml-auto mr-3"
              (click)="!loading ? onSubmit(true) : ''">
              {{'generic.buttons.save-draft' | translate}}
            </button>

            <!-- Submit Button (if Anagraphic is START) -->
            <button *ngIf="shouldShowAnagraphicAt('START')" [disabled]="loading"
              class="btn-custom border-0 d-flex align-items-center px-5 py-2" (click)="!loading ? onSubmit() : ''">
              <mat-icon class="mr-2">play_circle_outlined</mat-icon>
              {{'generic.buttons.save-and-send' | translate}}
            </button>

            <!-- Next Button (if Anagraphic is END) -->
            <button *ngIf="shouldShowAnagraphicAt('END')"
              class="btn-custom border-0 d-flex align-items-center px-5 py-2"
              (click)="validateQuestionsAndProceed(stepper)">
              <mat-icon class="mr-2">play_circle_outlined</mat-icon>
              {{'generic.next' | translate}}
            </button>
          </div>
        </div>
      </mat-step>

      <!-- END: Anagraphic Form Step -->
      <mat-step *ngIf="shouldShowAnagraphicAt('END')" [stepControl]="userInfoForm">
        <ng-template matStepLabel>{{ "generic.generic-info" | translate }}</ng-template>
        <div class="mt-5">
          <ng-container *ngTemplateOutlet="anagraphicFormContent"></ng-container>
        </div>
        <div class="row justify-content-between mt-5 mx-1">
          <button class="btn-custom border-0 d-flex align-items-center px-5 py-2" matStepperPrevious>
            {{'generic.back' | translate}}
          </button>
          <button [disabled]="loading" class="btn-custom border-0 d-flex align-items-center px-5 py-2"
            (click)="!loading ? onSubmit() : ''">
            <mat-icon class="mr-2">play_circle_outlined</mat-icon>
            {{'generic.buttons.save-and-send' | translate}}
          </button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>{{ 'generic.done' | translate }}</ng-template>
        <h4 class="font-weight-bold col-12 w-100 pl-0 mt-3 text-center">
          {{ 'pages.surveys.response.submitted-successfully' | translate }}
        </h4>
      </mat-step>
    </mat-stepper>
    <app-survey-details *ngIf="survey?.answered && !justSubmitted" [surveyObj]="survey" [isResponse]="true" />
  </div>
</div>
